import React, { useState, useEffect } from 'react'
import teacher from "../imgs/teacher.png"
import { Button, Form, Row, Col } from "react-bootstrap"
import Fade from 'react-reveal/Fade';
import InputField from '../components/InputField';
import { useStateMachine } from "little-state-machine";
import { useForm } from "react-hook-form";
import updateAction from "../updateAction";
import * as yup from "yup";
import { Navigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup"
import { Helmet } from 'react-helmet'
import { useNavigate } from "react-router-dom";
const Sstep2 = (props) => {
    let navigate = useNavigate();
    const [showSpouse, setshowSpouse] = useState(false);
    const { register, handleSubmit, formState: { errors } } = useForm({
        mode: "all"
        , resolver: yupResolver(schema)
    });
    const { state, actions } = useStateMachine({ updateAction });

    const onSubmit = data => {
        console.log(data);
        actions.updateAction(data);
        navigate("/Sstep3", { replace: true });

    };

    const [go, setgo] = useState(false);

    useEffect(() => {
        if (!state.firstname) {
            setgo(true);
            console.log("k k")
        }
    });

    return (
        <>
            <Helmet>
                <title>Registration</title>
            </Helmet>

            {go && (
                <Navigate to='/Sstep1' />
            )}
            <div className="bg"></div>
            <div className="bg bg2"></div>
            <div className="bg bg3"></div>
            {/* <div className="content"> */}

            <div className="container1">

                <div className="wrapper1">
                    <ul className="steps">
                        <li className="is-active">Step 3 of 6</li>
                    </ul>
                    <form className="form-wrapper1" onSubmit={handleSubmit(onSubmit)}>

                        <fieldset className="section is-active">
                            <Fade>
                                <>
                                    <h3>Welcome, {state.firstname}</h3>
                                    <p>Tell us a little more about yourself</p>

                                    <InputField register={register} errorinfo={errors} placeholder="Tabernacle of Prayer Point Fortin" label="Church you fellowship with" name="church" />
                                    <InputField type="date" register={register} errorinfo={errors} label="Date of Birth" name="dob" />
                                    <InputField type="tel" register={register} errorinfo={errors} label="Phone Number" name="Phone" />
                                    <Form.Group className="mb-3">
                                        <Form.Label>Gender</Form.Label>
                                        <select className="form-select"{...register("Gender")} name="Gender" required>
                                            <option></option>
                                            <option value="male">male</option>
                                            <option value="female">female</option>
                                        </select>
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Marital Status</Form.Label>
                                        <select className="form-select"{...register("marry")} name="marry"
                                            onChange={(e) => {
                                                if (e.target.value != "Single") {
                                                    setshowSpouse(true);
                                                } else {
                                                    setshowSpouse(false);
                                                }
                                            }}
                                            required>
                                            <option></option>
                                            <option value="Married">Married</option>
                                            <option value="Single">Single</option>
                                            <option value="Divorced">Divorced</option>
                                            <option value="Separated">Separated</option>
                                        </select>
                                    </Form.Group>
                                    {showSpouse && (
                                        <Fade>
                                            <>
                                                <InputField register={register} errorinfo={errors} placeholder="John Doe" label="Spouse's full name" name="SpouseName" />
                                            </>
                                        </Fade>
                                    )}
                                    <Button type="submit">next</Button>
                                </>
                            </Fade>
                        </fieldset>

                    </form>
                </div>
            </div>


            {/* </div> */}
        </>
    )
}
const schema = yup.object().shape({
    SpouseName: yup.string().when("marry", {
        is: "Married",
        then: yup.string().required("enter your spouse's name").min(3, "name must be at least 3 characters long")
    }).when("marry", {
        is: "Divorced",
        then: yup.string().required("enter your spouse's name").min(3, "name must be at least 3 characters long")
    }).when("marry", {
        is: "Separated",
        then: yup.string().required("enter your spouse's name").min(3, "name must be at least 3 characters long")
    }),
    church: yup.string().trim().required("enter your church's name"),
    Phone: yup.string().required("Enter a valid telephone number"),
    dob: yup.date().required("enter your date of birth"),

})


export default Sstep2
